import { BASE_URL } from "../config/settings";
import httpRequest from "../utils/httpRequest";


export const memberPaymentUpload = async ({feeType, payload}) => {
    return await httpRequest(
      `${BASE_URL}/v2/Import/payments?FeeType=${feeType}`,
      "post",
      payload,
      null,
      "multipart/form-data",
    );
  };

  export const memberDataUpload = async ({ payload}) => {
    return await httpRequest(
      `${BASE_URL}/v2/Import/members`,
      "post",
      payload,
      null,
      "multipart/form-data",
    );
  }